import React from 'react'
import { Button, Card, Checkbox, Form, Input, Typography } from 'antd'
import { IconSearch } from 'components/icons'
import TableSawitPoinRecevier from './TableSawitPoinRecevier'
import { AdminsUserListResponseItem } from 'generated/api'

interface IProps {
  dataSource: AdminsUserListResponseItem[]
  includeUser: AdminsUserListResponseItem[]
  handleInclude: (val: AdminsUserListResponseItem[]) => void
  excludeUser: AdminsUserListResponseItem[]
  handleExclude: (val: AdminsUserListResponseItem[]) => void
  selectAll: boolean
  handleSelectAll: (val: boolean) => void
  currentPage: number
  totalPages: number
  totalUsers: number
  changePage: (val: number) => void
  changeSearch: (val: string) => void
  loading: boolean
  search: string
  tableContainerRef: React.MutableRefObject<HTMLDivElement | null>
}

export default function FormSawitPoinReceiver(props: IProps) {
  const {
    excludeUser,
    handleExclude,
    includeUser,
    handleInclude,
    selectAll,
    handleSelectAll,
    totalUsers,
    dataSource,
    loading,
    search,
    tableContainerRef,
  } = props

  const onChangeAll = () => {
    handleExclude([])
    handleInclude([])
    handleSelectAll(true)
  }

  const onDeleteAll = () => {
    handleExclude([])
    handleInclude([])
    handleSelectAll(false)
  }

  const handleCheckUser = (user: AdminsUserListResponseItem) => {
    if (selectAll) {
      const prevArray = excludeUser
      const newArray = prevArray.includes(user)
        ? prevArray.filter(item => item !== user)
        : [...prevArray, user]
      handleExclude(newArray)
    } else {
      const prevArray = includeUser
      const newArray = prevArray.includes(user)
        ? prevArray.filter(item => item !== user)
        : [...prevArray, user]
      handleInclude(newArray)
    }
  }

  return (
    <Card>
      <div className="xl:w-2/5 xl:flex w-full">
        <h3 className="m-0 text-xl text-[#323539] self-center">2. Penerima SawitPoin</h3>
      </div>
      <Form className="mt-5">
        <Input
          prefix={<IconSearch />}
          className="w-full"
          data-testid="input-search-name"
          placeholder="Cari nama atau nomor telepon"
          onChange={({ target: { value } }) => props.changeSearch(value)}
        />
        <div className="flex flex-row justify-between">
          <div className="flex flex-col my-3">
            <Typography.Title className="text-sm">Daftar Pengguna</Typography.Title>
            {search === '' && (
              <Typography.Text className="text-gray-500">
                {selectAll ? totalUsers - excludeUser.length : includeUser.length} Terpilih
              </Typography.Text>
            )}
          </div>
          {search === '' && (
            <div className="flex flex-row items-center">
              {(includeUser.length > 0 || selectAll) && (
                <Button onClick={onDeleteAll} data-testid="delete-all">
                  <Typography.Title className="text-sm mr-10 text-red-500">
                    Hapus Semua
                  </Typography.Title>
                </Button>
              )}
              <div>
                <Checkbox
                  data-testid="select-all"
                  checked={excludeUser.length == 0 && selectAll}
                  onChange={() => onChangeAll()}
                >
                  Pilih semua pengguna
                </Checkbox>
              </div>
            </div>
          )}
        </div>
        <div className="table-sawitpoin">
          <TableSawitPoinRecevier
            tableContainerRef={tableContainerRef}
            dataSource={dataSource}
            selected={includeUser}
            onSelected={handleCheckUser}
            includeUser={includeUser}
            excludeUser={excludeUser}
            selectAll={selectAll}
            loading={loading}
          />
        </div>
      </Form>
    </Card>
  )
}
